module.exports = __webpack_public_path__ + "media/fonts/glyphicons-halflings-regular-be810be3.woff2";